import { render, staticRenderFns } from "./infrared.vue?vue&type=template&id=1318669e&scoped=true"
import script from "./infrared.vue?vue&type=script&lang=js"
export * from "./infrared.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=1318669e&prod&scoped=true&lang=css&external"
import style1 from "./infrared.vue?vue&type=style&index=1&id=1318669e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318669e",
  null
  
)

export default component.exports